import { gql } from "@apollo/client";

export const UPLOAD_ROSTER_MUTATION = gql`
  mutation UploadRoster(
    $file: Upload!
    $skipPreview: Boolean
    $executeImport: Boolean
    $programLevel: String!
    $universitySectionId: String!
  ) {
    universityImportRoster(
      file: $file
      skipPreview: $skipPreview
      executeImport: $executeImport
      programLevel: $programLevel
      universitySectionId: $universitySectionId
    ) {
      success
      errors
      successCount
      importedRecords {
        id
        displayName
      }
      failedRecords
      importCompleted
      warnings
      previewErrors {
        row
        issues
        type
        canImport
        studentData
      }
      previewWarnings {
        row
        issues
        type
        canImport
        studentData
      }
      previewValidRecords {
        row
        issues
        type
        canImport
        studentData
      }
    }
  }
`;

export const UPLOAD_ROSTER_PREVIEW_MUTATION = gql`
  mutation UploadRosterPreview($file: Upload!, $programLevel: String!, $universitySectionId: String!) {
    universityImportRosterPreview(file: $file, programLevel: $programLevel, universitySectionId: $universitySectionId) {
      success
      errors
      importCompleted
      warnings
      previewErrors {
        row
        issues
        type
        canImport
        studentData
      }
      previewWarnings {
        row
        issues
        type
        canImport
        studentData
      }
      previewValidRecords {
        row
        issues
        type
        canImport
        studentData
      }
    }
  }
`;

export const SUBMIT_STUDENT_ROSTER_MUTATION = gql`
  mutation SubmitStudentRoster(
    $universityId: ID!
    $validRecords: [BackofficeEducationValidatedStudentRecordInput!]!
    $warningRecords: [BackofficeEducationValidatedStudentRecordInput!]
  ) {
    submitStudentRoster(universityId: $universityId, validRecords: $validRecords, warningRecords: $warningRecords) {
      success
      errors {
        base
      }
      roster {
        id
        status
      }
      validRecordsCount
      warningsCount
    }
  }
`;

export const DELETE_ROSTER_ROW = gql`
  mutation DeleteUniversityRosterRow($rosterRowId: ID!) {
    deleteUniversityRosterRow(rosterRowId: $rosterRowId) {
      success
      errors {
        field
        base
      }
      roster {
        id
        status
        studentCount
      }
    }
  }
`;

export const UPDATE_ROSTER_ROW = gql`
  mutation UpdateUniversityRosterRow($rosterRowId: ID!, $input: BackofficeEducationUpdateUniversityRosterRowInput!) {
    updateUniversityRosterRow(rosterRowId: $rosterRowId, input: $input) {
      success
      errors {
        field
        base
      }
      rosterRow {
        id
        educationLevel
        handicap
        transferHours
        person {
          id
          firstName
          lastName
          email
          pgaId
        }
      }
    }
  }
`;
